/**
 * Bundle Fix - Kingbriefs
 * 1. Hide qty selector when 3-pair or 5-pair tier is selected
 * 2. Show qty selector when 1-pair tier is selected
 */
(function() {
  'use strict';

  function updateQtyVisibility() {
    var volumeWidget = document.querySelector('.appstle-volume-discount');
    if (!volumeWidget) return;

    var qtyWrapper = document.querySelector('.product-form__quantity');
    if (!qtyWrapper) return;

    // Check if a non-first tier is selected
    var selectedTier = volumeWidget.querySelector('.ab-volume-discount-item-selected');
    var firstTier = volumeWidget.querySelector('.ab-volume-discount-item-container:first-of-type');

    if (selectedTier && firstTier && selectedTier !== firstTier) {
      // 3-pair or 5-pair selected: hide qty
      qtyWrapper.style.display = 'none';
    } else {
      // 1-pair selected or no selection: show qty
      qtyWrapper.style.display = '';
    }
  }

  function init() {
    var volumeWidget = document.querySelector('.appstle-volume-discount');
    if (!volumeWidget) {
      setTimeout(init, 500);
      return;
    }

    // Listen for clicks on volume discount tiers
    volumeWidget.addEventListener('click', function() {
      setTimeout(updateQtyVisibility, 100);
    });

    // Initial check
    updateQtyVisibility();
  }

  window.addEventListener('load', function() {
    setTimeout(init, 2000);
  });

  if (document.readyState !== 'loading') {
    setTimeout(init, 1500);
  }
})();
